<script setup>
import { ref } from 'vue'

const type = ref('wide')
</script>

<template>
    <div class="container mx-auto pt-3">
        <RouterView v-slot="{ Component }">
            <template v-if="Component">
                <component :is="Component" />
            </template>
            <div v-else class="w-full h-screen bg-dust-50 rounded-md flex items-center justify-center animate-pulse"></div>
        </RouterView>
    </div>
</template>